import { AlertBanner } from "@kivunova/kivufrontendcommon";
import {
  fetchGraphQL as fetchGraphQLCommon,
  uploadFileGraphQL as uploadFileGraphQLCommon,
} from "@kivunova/kivufrontendcommon";
import { captureSentryException } from "../sentry/sentryLogs";

// Wrapper functions that add Sentry error handling
export const fetchGraphQL = async <T, E>(
  query: string,
  variables: E,
  setAlert: (alert: AlertBanner) => void,
): Promise<T> => {
  return fetchGraphQLCommon(
    query,
    variables,
    setAlert,
    captureSentryException,
    {
      suppressUnauthorizedRedirect: true,
    },
  );
};

export const uploadFileGraphQL = async <T, E>(
  query: string,
  variables: E,
  file: File,
  setAlert: (alert: AlertBanner) => void,
): Promise<T> => {
  return uploadFileGraphQLCommon(
    query,
    variables,
    file,
    setAlert,
    captureSentryException,
  );
};
